import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom';
import { Container, Navbar, Nav, Button, NavDropdown, Form , Col, Row, Offcanvas, Spinner, Card} from 'react-bootstrap';
import logo from '../images/logo.svg'
import caramel from '../images/caramel.svg'


const ProfileNavbar = ({userData, handleLogout, setUserData}) => {
  const navigate = useNavigate();
  const [isCollapsed, setCollapsed] = useState(true);

  const handleToggle = () => {
    setCollapsed(!isCollapsed);
  };

  const handleLinkClick = () => {
    setCollapsed(true);
  };
  
  const persistUserData = (userData) => {
    localStorage.setItem('userData', JSON.stringify(userData));
  };

  useEffect(() => {
    // Check if user data is available in localStorage
    const storedUserData = JSON.parse(localStorage.getItem('userData'));
    if (storedUserData) {
      // Set user data from localStorage if available
      setUserData(storedUserData);
    }
  }, []); // Run this effect only once on component mount

  // Update localStorage whenever userData prop changes
  useEffect(() => {
    if (userData) {
      persistUserData(userData);
    }
  }, [userData]);

  const handleLogoutClick=()=> {
   handleLogout();
   navigate('/login');
  }
  ;
  const location = useLocation();
  const showNavbar = location.pathname === '/profile'
  || location.pathname === '/user-booking'  || location.pathname === '/user-accommodation' || location.pathname === '/available-flight' || location.pathname === '/hotel-search' || location.pathname === '/user-accommodation' || location.pathname === '/usersubscribe'  ||  location.pathname.includes('/flight-itinerary') || location.pathname.includes('/hotel-itinerary') || location.pathname === '/carRentals' || location.pathname === '/available-cars' || location.pathname.includes('/car-itinerary') ;

  // Conditionally render the navbar based on showNavbar prop
  if (!showNavbar) {
    return null;
  }

  if (userData){
   const {name,email}= userData
  
   return (
   
     <Navbar expand="lg" variant="light" bg="white" className='px-3 px-sm-5'>
  
  <Navbar.Brand className=''>
    <Link to='/'>
    <img src={logo} alt="Tripz-logo" style={{width:'100px', marginBottom:'15px'}} />
    </Link>
  </Navbar.Brand>
  <Navbar.Toggle onClick={handleToggle} aria-controls="responsive-navbar-nav"/>
  <Navbar.Collapse in={!isCollapsed} >
    <Nav className="mx-auto gap-2 gap-md-4" style={{fontWeight:'600', color:'#292D32'}} onClick={handleLinkClick}>
      <Nav.Link onClick={() => navigate('/user-booking')}>Bookings</Nav.Link>
     
      
      <Nav.Link onClick={() => navigate('/carRentals')}>Rentals</Nav.Link>
      <Nav.Link onClick={() => navigate('/user-accommodation')}>Explore</Nav.Link>
    </Nav>
    <Nav className="gap-3 " style={{fontWeight:'600', color:'#292D32'}}>
      
      <NavDropdown title="NGN" id="collasible-nav-dropdown"className='mt-3 '>
        <NavDropdown.Item href="#action1">Ghana</NavDropdown.Item>
        <NavDropdown.Item href="#action2">Canada</NavDropdown.Item>
        <NavDropdown.Item href="#action3">America</NavDropdown.Item>
      </NavDropdown>
      <Nav  onClick={handleLinkClick}>
      <Nav.Link onClick={()=> navigate('/profile')}className='d-flex gap-2 '>
       
        <img src={caramel} className='' alt='caramel'/>
        <div className=''>
         <h6 className='username'>{name}</h6>
         <p className='email-add mb-1'>{email}</p>
        </div>
      </Nav.Link>
      </Nav>
      <Nav onClick={handleLinkClick}>
      <Nav.Link>
        
        <Button onClick={handleLogoutClick} style={{height: '48px',
width: '180px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
         Log Out
        </Button>
        
      </Nav.Link>    
      </Nav>
    </Nav>
  </Navbar.Collapse>

 </Navbar>)}
  return (
    <Navbar expand="lg" variant="light" bg="white" className='px-3 px-sm-5'>
 
 <Navbar.Brand className=''>
   <Link to='/'>
   <img src={logo} alt="Tripz-logo" style={{width:'100px', marginBottom:'15px'}} />
   </Link>
 </Navbar.Brand>
 <Navbar.Toggle aria-controls="navbarSupportedContent" />
 <Navbar.Collapse id="navbarSupportedContent" >
   <Nav className="mx-auto gap-2 gap-md-4" style={{fontWeight:'600', color:'#292D32'}}>
   <Nav.Link onClick={() => navigate('/user-booking')}>Bookings</Nav.Link>
     
      
     <Nav.Link onClick={() => navigate('/carRentals')}>Rentals</Nav.Link>
     <Nav.Link onClick={() => navigate('/user-accommodation')}>Explore</Nav.Link>
   </Nav>
   <Nav className="gap-3 " style={{fontWeight:'600', color:'#292D32'}}>
     
     <NavDropdown title="NGN" id="navbar-dropdown" className='mt-3 '>
       <NavDropdown.Item href="#action1">Naira</NavDropdown.Item>
       <NavDropdown.Item href="#action2">USD</NavDropdown.Item>
       <NavDropdown.Item href="#action3">Pounds</NavDropdown.Item>
     </NavDropdown>
     <Nav.Link onClick={()=> navigate('/profile')} className='d-flex gap-3'>
      
       <img src={caramel} alt='caramel'/>
       <div>
       <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
       </div>
     </Nav.Link>
     <Nav.Link>
       
     <Button onClick={handleLogoutClick} style={{height: '48px',
width: '241px',

borderRadius: '8px',

backgroundColor: '#008080'}}>
        Log Out
       </Button>
     </Nav.Link>    
   </Nav>
 </Navbar.Collapse>

</Navbar>
        
       
    
  );
};

export default ProfileNavbar;
